function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import './BingMapsLayer';
import olSourceBingMaps from 'ol/source/BingMaps';
import olLayerTile from 'ol/layer/Tile';
import { BingMapsLayerModelBuilder } from './BingMapsLayerModelBuilder';
import { getZoomLevelHelper } from '../../util/scale';
var AbstractMapLayerPlugin = Oskari.clazz.get('Oskari.mapping.mapmodule.AbstractMapLayerPlugin');
var LayerComposingModel = Oskari.clazz.get('Oskari.mapframework.domain.LayerComposingModel');
var BingMapsLayerPlugin = /*#__PURE__*/function (_AbstractMapLayerPlug) {
  function BingMapsLayerPlugin(config) {
    var _this;
    _classCallCheck(this, BingMapsLayerPlugin);
    _this = _callSuper(this, BingMapsLayerPlugin, [config]);
    _this.__name = 'BingMapsLayerPlugin';
    _this._clazz = 'Oskari.mapframework.mapmodule.BingMapsLayerPlugin';
    _this.layertype = 'bingmaps';
    return _this;
  }
  /**
   * @private @method _initImpl
   * Interface method for the module protocol.
   */
  _inherits(BingMapsLayerPlugin, _AbstractMapLayerPlug);
  return _createClass(BingMapsLayerPlugin, [{
    key: "_initImpl",
    value: function _initImpl() {
      // register domain builder
      var mapLayerService = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
      if (mapLayerService) {
        var composingModel = new LayerComposingModel([LayerComposingModel.API_KEY, LayerComposingModel.SRS]);
        mapLayerService.registerLayerModel(this.layertype + 'layer', this._getLayerModelClass(), composingModel);
        mapLayerService.registerLayerModelBuilder(this.layertype + 'layer', this._getModelBuilder());
      }
    }
    /**
     * @private @method _getLayerModelClass
     * Returns class to be used as mapLayerService layer model
     */
  }, {
    key: "_getLayerModelClass",
    value: function _getLayerModelClass() {
      return 'Oskari.mapframework.mapmodule.BingMapsLayer';
    }
    /**
     * @private @method _getModelBuilder
     * Returns object to be used as mapLayerService layer model builder
     */
  }, {
    key: "_getModelBuilder",
    value: function _getModelBuilder() {
      return new BingMapsLayerModelBuilder();
    }
    /**
     * @private @method _createPluginEventHandlers
     * Called by superclass to create event handlers
     */
  }, {
    key: "_createPluginEventHandlers",
    value: function _createPluginEventHandlers() {
      return {
        AfterChangeMapLayerStyleEvent: function AfterChangeMapLayerStyleEvent(event) {
          this._updateLayerStyle(event.getMapLayer());
        }
      };
    }
    /**
     * @private @method _updateLayerStyle
     * @param {Oskari.mapframework.mapmodule.BingMapsLayer} oskariLayer
     */
  }, {
    key: "_updateLayerStyle",
    value: function _updateLayerStyle(oskariLayer) {
      var olLayers = this.getOLMapLayers(oskariLayer) || [];
      if (!olLayers.length) {
        return;
      }
      var mapmodule = this.getMapModule();
      var lyrWithOldSource = olLayers[0];
      var lyrIndex = mapmodule.getMap().getLayers().getArray().indexOf(lyrWithOldSource);
      // Create a new layer with the selected style and replace the old one.
      var lyrWithNewSource = this._createOlLayer(oskariLayer);
      mapmodule.getMap().getLayers().insertAt(lyrIndex + 1, lyrWithNewSource);
      this.setOLMapLayers(oskariLayer.getId(), lyrWithNewSource);
      // Keep the old layer in the background till the new layer has had time to load.
      var removeOldLyrTimeout = 3000;
      setTimeout(function () {
        mapmodule.getMap().removeLayer(lyrWithOldSource);
      }, removeOldLyrTimeout);
    }
    /**
     * Checks if the layer can be handled by this plugin
     * @method  isLayerSupported
     * @param  {Oskari.mapframework.domain.AbstractLayer} layer
     * @return {Boolean}       true if this plugin handles the type of layers
     */
  }, {
    key: "isLayerSupported",
    value: function isLayerSupported(layer) {
      if (!layer) {
        return false;
      }
      return layer.isLayerOfType(this.layertype);
    }
    /**
     * @method addMapLayerToMap
     * @private
     * @param {Oskari.mapframework.domain.BingMapsLayer} layer
     * @param {Boolean} keepLayerOnTop
     * @param {Boolean} isBaseMap
     */
  }, {
    key: "addMapLayerToMap",
    value: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
      var bingMapsLayer = this._createOlLayer(layer);
      this.getMapModule().addLayer(bingMapsLayer, !keepLayerOnTop);
      this.setOLMapLayers(layer.getId(), bingMapsLayer);
    }

    /**
     * @private
     * @method _createOlLayer Creates a new ol.layer.Tile layer with a Bing Maps source
     * @param {Oskari.mapframework.domain.BingMapsLayer} layer
     */
  }, {
    key: "_createOlLayer",
    value: function _createOlLayer(layer) {
      var bingMapsLayer = new olLayerTile({
        opacity: layer.getOpacity() / 100,
        source: this._createSource(layer)
      });
      var zoomLevelHelper = getZoomLevelHelper(this.getMapModule().getScaleArray());
      // Set min max zoom levels that layer should be visible in
      zoomLevelHelper.setOLZoomLimits(bingMapsLayer, layer.getMinScale(), layer.getMaxScale());
      return bingMapsLayer;
    }
  }, {
    key: "_createSource",
    value: function _createSource(oskariLayer) {
      var style = oskariLayer.getCurrentStyle();
      var opts = {
        key: oskariLayer.getApiKey(),
        imagerySet: style ? style.getName() : 'RoadOnDemand',
        maxZoom: 19
      };
      return new olSourceBingMaps(opts);
    }
    /**
     * Called when layer details are updated (for example by the admin functionality)
     * @param {Oskari.mapframework.domain.AbstractLayer} layer new layer details
     */
  }, {
    key: "_updateLayer",
    value: function _updateLayer(layer) {
      if (!this.isLayerSupported(layer)) {
        return;
      }
      var zoomLevelHelper = getZoomLevelHelper(this.getMapModule().getScaleArray());
      var layersImpls = this.getOLMapLayers(layer.getId()) || [];
      layersImpls.forEach(function (olLayer) {
        // Update min max Resolutions
        zoomLevelHelper.setOLZoomLimits(olLayer, layer.getMinScale(), layer.getMaxScale());
      });
    }
  }]);
}(AbstractMapLayerPlugin);
Oskari.clazz.defineES('Oskari.mapframework.mapmodule.BingMapsLayerPlugin', BingMapsLayerPlugin, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});
export { BingMapsLayerPlugin };